import { __rest, __assign } from 'tslib';
import { jsx } from '@emotion/react/jsx-runtime';
import { forwardRef } from 'react';
import { useTheme } from '../hooks/useTheme.js';
import { tdStyle } from './Td.js';

var Th = forwardRef(function Th(_a, ref) {
    var _b = _a.themeKey, themeKey = _b === void 0 ? "tableCellHead" : _b, props = __rest(_a, ["themeKey"]);
    var handleStyleProps = useTheme().handleStyleProps;
    var forwardProps = handleStyleProps(props, {
        themeKey: themeKey,
        baseStyle: __assign({}, tdStyle),
    });
    return jsx("th", __assign({ "data-table-cell-head": true, ref: ref }, forwardProps));
});

export { Th };
//# sourceMappingURL=Th.js.map
